import React, { ReactNode, createContext, useContext, useMemo } from 'react';

import { useApiView } from '@futrli/views/hooks/useApiView';
import { SharingView } from '@futrli/views/views/sharing/SharingView/SharingView';

import { SharingEntityType } from '../../../../core/api/sharing';
import { useRouteIds } from '../../../../hooks/useRouteIds';
import { useShareResourceForm } from '../hooks/use-share-resource-form';

interface ShareResourceContextProps {
  children?: ReactNode;
  entityId: string;
  entityType: SharingEntityType;
}

interface ShareResourceContextValues {
  form: ReturnType<typeof useShareResourceForm>;
  view: SharingView;
}

const defaultState = ({} as unknown) as ShareResourceContextValues;

export const ShareResourceContext = createContext(defaultState);

export const ShareResourceContextProvider = ({ children, entityId, entityType }: ShareResourceContextProps) => {
  const { workspaceId, organisationId, isConsolidation } = useRouteIds();
  const view = useApiView(
    useMemo(
      () => new SharingView(workspaceId, organisationId, entityType, entityId, isConsolidation),
      [workspaceId, organisationId, entityType, entityId, isConsolidation]
    )
  );
  const form = useShareResourceForm(view.state.resourcePermissions);

  const values: ShareResourceContextValues = {
    form,
    view
  };

  return <ShareResourceContext.Provider value={values}>{children}</ShareResourceContext.Provider>;
};

export const useShareResourceContext = () => useContext(ShareResourceContext);
